export const SET_CUSTOMIZE_UI = "SET_CUSTOMIZE_UI";

export const setCustomizeUiData = (data) => {
  return {
    type: SET_CUSTOMIZE_UI,
    payload: data,
  };
};
